import React from 'react';
import EmailAndPassword from '../../../components/Pages/Auth/SignIn/EmailAndPassword';
import Simple from '../../../components/Layout/Simple';
import SignInContent from '../../../components/Pages/Auth/SignIn';

function SignIn(): JSX.Element {
  document.title = `${process.env.REACT_APP_TITLE}: Sign in`;

  return (
    <Simple>
      <SignInContent content={EmailAndPassword} />
    </Simple>
  );
}

export default SignIn;
